<template>
  <div>
    <nav
      class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
      id="layout-navbar"
    >
      <div
        class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
      >
        <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
          <i class="ti ti-menu-2 ti-md"></i>
        </a>
      </div>

      <div
        class="navbar-nav-right d-flex align-items-center"
        id="navbar-collapse"
      >
        <!-- Search -->
        <div class="navbar-nav align-items-center">
          <div class="input-group input-group-merge">
            <span class="input-group-text" id="basic-addon-search31"
              ><i class="ti ti-search"></i
            ></span>
            <input
              type="search"
              @change="triggerSearch"
              v-model="search.value"
              class="form-control"
              :placeholder="`${$t('control.search')}...`"
              aria-label="`${$t('control.search')}...`"
              aria-describedby="basic-addon-search31"
            />
          </div>
        </div>
        <!-- /Search -->

        <ul class="navbar-nav flex-row align-items-center ms-auto">
          <!-- Language -->
          <li class="nav-item dropdown-language dropdown">
            <a
              class="nav-link btn btn-text-secondary btn-icon rounded-pill dropdown-toggle hide-arrow"
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-language rounded-circle ti-md"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  @click.prevent="changeLanguage('en')"
                  data-language="en"
                  data-text-direction="ltr"
                >
                  <span>English</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  data-language="fr"
                  data-text-direction="ltr"
                >
                  <span>Turkçe</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  data-language="ar"
                  @click.prevent="changeLanguage('ar')"
                  data-text-direction="rtl"
                >
                  <span>العربية</span>
                </a>
              </li>
            </ul>
          </li>
          <!--/ Language -->

          <!-- Style Switcher -->
          <li class="nav-item dropdown-style-switcher dropdown">
            <a
              class="nav-link btn btn-text-secondary btn-icon rounded-pill dropdown-toggle hide-arrow"
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-md"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-end dropdown-styles">
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  data-theme="light"
                >
                  <span class="align-middle"
                    ><i class="ti ti-sun ti-md me-3"></i
                    >{{ $t("control.light") }}</span
                  >
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  data-theme="dark"
                >
                  <span class="align-middle"
                    ><i class="ti ti-moon-stars ti-md me-3"></i
                    >{{ $t("control.dark") }}</span
                  >
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  data-theme="system"
                >
                  <span class="align-middle"
                    ><i class="ti ti-device-desktop-analytics ti-md me-3"></i
                    >{{ $t("control.system") }}</span
                  >
                </a>
              </li>
            </ul>
          </li>
          <!-- / Style Switcher-->

          <!-- Notification -->
          <!-- <li
            class="nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-2"
          >
            <a
              class="nav-link btn btn-text-secondary btn-icon rounded-pill dropdown-toggle hide-arrow"
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-expanded="false"
            >
              <span class="position-relative">
                <i class="ti ti-bell ti-md"></i>
                <span
                  class="badge rounded-pill bg-danger badge-dot badge-notifications border"
                ></span>
              </span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-0">
              <li class="dropdown-menu-header border-bottom">
                <div class="dropdown-header d-flex align-items-center py-3">
                  <h6 class="mb-0 me-auto">Notification</h6>
                  <div class="d-flex align-items-center h6 mb-0">
                    <span class="badge bg-label-primary me-2">8 New</span>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-text-secondary rounded-pill btn-icon dropdown-notifications-all"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Mark all as read"
                      ><i class="ti ti-mail-opened text-heading"></i
                    ></a>
                  </div>
                </div>
              </li>
              <li class="dropdown-notifications-list scrollable-container">
                <ul class="list-group list-group-flush">
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <img
                            src="@/assets/img/avatars/1.png"
                            alt
                            class="rounded-circle"
                          />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="small mb-1">Congratulation Lettie 🎉</h6>
                        <small class="mb-1 d-block text-body"
                          >Won the monthly best seller gold badge</small
                        >
                        <small class="text-muted">1h ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <span
                            class="avatar-initial rounded-circle bg-label-danger"
                            >CF</span
                          >
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">Charles Franklin</h6>
                        <small class="mb-1 d-block text-body"
                          >Accepted your connection</small
                        >
                        <small class="text-muted">12hr ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <img
                            src="@/assets/img/avatars/2.png"
                            alt
                            class="rounded-circle"
                          />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">New Message ✉️</h6>
                        <small class="mb-1 d-block text-body"
                          >You have new message from Natalie</small
                        >
                        <small class="text-muted">1h ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <span
                            class="avatar-initial rounded-circle bg-label-success"
                            ><i class="ti ti-shopping-cart"></i
                          ></span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">Whoo! You have new order 🛒</h6>
                        <small class="mb-1 d-block text-body"
                          >ACME Inc. made new order $1,154</small
                        >
                        <small class="text-muted">1 day ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <img
                            src="@/assets/img/avatars/9.png"
                            alt
                            class="rounded-circle"
                          />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">
                          Application has been approved 🚀
                        </h6>
                        <small class="mb-1 d-block text-body"
                          >Your ABC project application has been
                          approved.</small
                        >
                        <small class="text-muted">2 days ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <span
                            class="avatar-initial rounded-circle bg-label-success"
                            ><i class="ti ti-chart-pie"></i
                          ></span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">Monthly report is generated</h6>
                        <small class="mb-1 d-block text-body"
                          >July monthly financial report is generated
                        </small>
                        <small class="text-muted">3 days ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <img
                            src="@/assets/img/avatars/5.png"
                            alt
                            class="rounded-circle"
                          />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">Send connection request</h6>
                        <small class="mb-1 d-block text-body"
                          >Peter sent you connection request</small
                        >
                        <small class="text-muted">4 days ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <img
                            src="@/assets/img/avatars/6.png"
                            alt
                            class="rounded-circle"
                          />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">New message from Jane</h6>
                        <small class="mb-1 d-block text-body"
                          >Your have new message from Jane</small
                        >
                        <small class="text-muted">5 days ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                  >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <span
                            class="avatar-initial rounded-circle bg-label-warning"
                            ><i class="ti ti-alert-triangle"></i
                          ></span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">CPU is running high</h6>
                        <small class="mb-1 d-block text-body"
                          >CPU Utilization Percent is currently at
                          88.63%,</small
                        >
                        <small class="text-muted">5 days ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
              <li class="border-top">
                <div class="d-grid p-4">
                  <a
                    class="btn btn-primary btn-sm d-flex"
                    href="javascript:void(0);"
                  >
                    <small class="align-middle">View all notifications</small>
                  </a>
                </div>
              </li>
            </ul>
          </li> -->
          <!--/ Notification -->

          <!-- Client Logo -->

          <li class="client-logo text-center mx-1">
            <!-- <img
              class="client-logo-light"
              src="@/assets/img/company-logo-light.svg"
              alt
            />
            <img
              class="client-logo-dark"
              src="@/assets/img/company-logo-dark.svg"
              alt
            /> -->
            <div>{{ settings.network_name }}</div>
            <div>{{ settings.license.realm }}</div>
          </li>

          <li
            v-if="settings.network_logo"
            class="client-logo d-flex flex-col align-items-center"
            style="width: 2.5rem; margin-right: 1.2rem; margin-left: 1.2rem"
          >
            <img
              class="client-logo-light img-fluid h-12"
              :src="server_url + settings.network_logo"
              alt
            />
            <img
              class="client-logo-dark img-fluid h-12"
              :src="server_url + settings.network_logo"
              alt
            />
          </li>
          <li
            v-else
            class="client-logo"
            style="width: 5.5rem; margin-right: 1.2rem; margin-left: 1.2rem"
          >
            <img
              class="client-logo-light"
              src="@/assets/img/company-logo-light.svg"
              alt
            />
            <img
              class="client-logo-dark"
              src="@/assets/img/company-logo-dark.svg"
              alt
            />
          </li>

          <!-- Client Logo -->

          <!-- User -->
          <li class="nav-item navbar-dropdown dropdown-user dropdown">
            <a
              class="nav-link dropdown-toggle hide-arrow p-0"
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
            >
              <div class="avatar avatar-online">
                <img
                  v-if="user.profile_image"
                  :src="server_url + user.profile_image"
                  alt
                  class="rounded-circle h-12"
                />
                <img
                  v-else
                  src="@/assets/img/avatars/1.png"
                  alt
                  class="rounded-circle"
                />
              </div>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <button
                  class="dropdown-item mt-0"
                  @click.prevent="openEditProfileModal"
                >
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-2">
                      <div class="avatar avatar-online">
                        <img
                          v-if="user.profile_image"
                          :src="server_url + user.profile_image"
                          alt
                          class="rounded-circle"
                        />
                        <img
                          v-else
                          src="@/assets/img/avatars/1.png"
                          alt
                          class="rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-0">
                        {{ user.first_name + " " + user.last_name }}
                      </h6>
                      <small class="text-muted">{{
                        $t(`admins.${user.type}`)
                      }}</small>
                    </div>
                  </div>
                </button>
              </li>
              <li>
                <div class="dropdown-divider my-1 mx-n2"></div>
              </li>
              <li>
                <button
                  class="dropdown-item"
                  @click.prevent="openEditProfileModal"
                >
                  <i class="ti ti-user me-3 ti-md"></i
                  ><span class="align-middle">{{
                    $t("login.my_profile")
                  }}</span>
                </button>
              </li>
              <!-- <li>
                <a
                  class="dropdown-item"
                  href="pages-account-settings-account.html"
                >
                  <i class="ti ti-settings me-3 ti-md"></i
                  ><span class="align-middle">Settings</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="pages-account-settings-billing.html"
                >
                  <span class="d-flex align-items-center align-middle">
                    <i class="flex-shrink-0 ti ti-file-dollar me-3 ti-md"></i
                    ><span class="flex-grow-1 align-middle">Billing</span>
                    <span
                      class="flex-shrink-0 badge bg-danger d-flex align-items-center justify-content-center"
                      >4</span
                    >
                  </span>
                </a>
              </li>
              <li>
                <div class="dropdown-divider my-1 mx-n2"></div>
              </li>
              <li>
                <a class="dropdown-item" href="https://ssradius.com">
                  <i class="ti ti-currency-dollar me-3 ti-md"></i
                  ><span class="align-middle">Pricing</span>
                </a>
              </li> -->
              <li>
                <a class="dropdown-item" href="https://ssradius.com">
                  <i class="ti ti-question-mark me-3 ti-md"></i
                  ><span class="align-middle">SSRadius</span>
                </a>
              </li>
              <li>
                <div class="d-grid px-2 pt-2 pb-1">
                  <button
                    @click.prevent="handleLogout"
                    class="btn btn-sm btn-danger d-flex"
                    target="_blank"
                  >
                    <small class="align-middle">{{ $t("login.logout") }}</small>
                    <i class="ti ti-logout ms-2 ti-14px"></i>
                  </button>
                </div>
              </li>
            </ul>
          </li>
          <!--/ User -->
        </ul>
      </div>

      <!-- Search Small Screens -->
      <div class="navbar-search-wrapper search-input-wrapper d-none">
        <input
          type="search"
          class="form-control search-input container-xxl border-0"
          @change="triggerSearch"
          v-model="search.value"
          :placeholder="`${$t('control.search')}...`"
          aria-label="`${$t('control.search')}...`"
        />
        <i class="ti ti-x search-toggler cursor-pointer"></i>
      </div>
    </nav>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "navbar",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      server_url: localStorage.getItem("server"),
      search: {
        value: null,
      },
      showEditProfile: false,
    };
  },
  methods: {
    async handleLogout() {
      try {
        const response = await axios.post("users/logout");
        if (response.status == 200) {
          localStorage.removeItem("token");
          localStorage.removeItem("server");
          localStorage.removeItem("server_api");
          this.$store.dispatch("user", null);
          this.$store.dispatch("settings", null);
          window.location.reload();
        }
      } catch (error) {
        this.$swal({
          title: this.$t("control.error"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          icon: "error",
          confirmButtonText: this.$t("control.ok"),
          backdrop: true,
        });
      }
    },
    async openEditProfileModal() {
      this.$router.push("/personal");
    },
    changeLanguage(lang) {
      if (lang == "en") {
        window.templateCustomizer.setLang("en");
        window.templateCustomizer.setRtl(false);
        localStorage.setItem("lang", "en");
      } else if (lang == "tr") {
        window.templateCustomizer.setLang("tr");
        window.templateCustomizer.setRtl(false);
        localStorage.setItem("lang", "tr");
      } else if (lang == "ar") {
        window.templateCustomizer.setLang("ar");
        window.templateCustomizer.setRtl(true);
        localStorage.setItem("lang", "ar");
      }
    },
    triggerSearch() {
      if (this.search.value) {
        this.$router.push({
          name: "Search",
          query: { query: this.search.value },
        });
      }
    },
  },
};
</script>
